var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "contents" }, [
    _c(
      "div",
      { staticClass: "content-wrap" },
      [
        _c("p", { staticClass: "headline" }, [
          _vm._v("\n        This page could not be found!\n      "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text" }, [
          _vm._v(
            "\n        We are sorry. But the page you are looking for is not available.\n      "
          ),
        ]),
        _vm._v(" "),
        _c("router-link", { staticClass: "button", attrs: { to: "/" } }, [
          _vm._v("BACK TO HOMEPAGE"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }